import { Logo } from '../../ui-kit/assets';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ActionButton, Input } from '../../ui-kit/components';
import moment from 'moment'

import styles from './ChooseFund.module.scss';
import { chooseFund, getBalanceInvestment, getBalanceWallet, getFundByCpu, getFundsUser, getTotalBalance } from '../../http/fundApi';
import { alertDanger, alertSuccess, DASHBOARD_ROUTER } from '../../utils/consts';
import { actionSetBalance, actionSetBalanceInvestment, actionSetBalanceWallet, actionSetFunds } from '../../store/actionCreators/fundActionCreator';
import { useDispatch, useSelector } from 'react-redux';

export const ChooseFundStep1 = () => {
  
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { cpu } = useParams()

  const [amount, setAmount] = useState()
  const [fund, setFund] = useState({})

  const browser_history = useSelector((state) => state.site.browser_history)

  const close = () => {
    navigate(browser_history[0])
  }

  const clickBtnChooseFund = async () => {
    try {
      let data = await chooseFund(amount, cpu)

      let total_balance = await getTotalBalance()
      dispatch(actionSetBalance(total_balance.balance))

      let fund_user = await getFundsUser()
      dispatch(actionSetFunds(fund_user))
        
      let balance_wallet = await getBalanceWallet()
      dispatch(actionSetBalanceWallet(balance_wallet.amount))

      let balance_investment = await getBalanceInvestment()
      dispatch(actionSetBalanceInvestment(balance_investment.amount))

      alertSuccess(dispatch,data.message)
      navigate(DASHBOARD_ROUTER)

    } catch (e) {
      alertDanger(dispatch,e.response.data.message)
    }
  }

  const load_data = async () => {
    let fund_data = await getFundByCpu(cpu)
    setFund(fund_data)
  }

  useEffect(() => {
    load_data()
  },[])

  
  let min = moment().format('m')
  let sec = moment().format('s')
  
  let min_will = 60 - Number(min) - 1
  let sec_will = 60 - Number(sec)

  return (
    <>
      <div className={styles.font}></div>
      <div className={styles.body}>
        <div className={styles['content']}>
          
          <div>Этап 1/2</div>
          <div style={{textAlign: 'center', marginBottom: 15}}>
            <img className={styles['logo-img']} src={Logo}/>
          </div>

          <h1 className={styles.title}>Инвестировать в фонд </h1>
          <h1 className={styles.title}>"{ fund?.name }" </h1>

          <h3 className={styles.under_title}>Ознакомьтесь с условиями управляющего</h3>

          { fund?.minimum_investment_amount_usd > 0 && <p className={styles.li}>Минимальная сумма входа в фонд &nbsp;<span style={{fontWeight: '600', color: 'white'}}>{ fund?.minimum_investment_amount_usd } USD</span>.</p> }
          { fund?.isset_month_comission == 1 && <p className={styles.li}>Комиссия с прибыли <span>{ fund?.comission_profit }%</span>. Списание  01 числа ежемесячно</p> }
          { fund?.isset_daily_comission == 1 && <p className={styles.li}>Комиссия сервиса <span>до 5%</span> от объема инвестиций. Списание ежедневно</p> }
          <p className={styles.li}>Ролловер каждые 60 минут. Вы присоединитесь к фонду через <span>{ min_will } мин { sec_will } сек</span></p>

          <div className={styles.form_footer}>
            <ActionButton onClick={() => close()} className={styles.button_cancel}>Отменить</ActionButton>
            <ActionButton onClick={() => navigate('/choose-fund-step-2/' + cpu)} className={styles.button}>Далее</ActionButton>
          </div>

        </div>
      </div>
    </> 
  );
};
